import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../components/Botao';
import { CorpoDaPagina } from '../../components/CorpoDaPagina';
import { Icone } from '../../components/Icone';
import { Input } from '../../components/Input';
import { Modal } from '../../components/Modal';
import { Seletor } from '../../components/Seletor';
import { Tabela } from '../../components/Tabela';
import { InstituicaoStore } from '../../stores/InstituicaoStore';
import { MunicipioStore } from '../../stores/MunicipioStore';
import { UsuarioInstituicaoStore } from '../../stores/UsuarioInstituicaoStore';
import { Formulario, CampoConteiner, ConteinerBotoes } from './styles';

function Usuario() {
  const [dependencia, atribuirDependencia] = useState('');
  const [filtros, atribuirFiltros] = useState({});
  const [instituicoes, atribuirInstituicoes] = useState([]);
  const [municipios, atribuirMunicipios] = useState([]);
  const [municipioNome, atribuirMunicipioNome] = useState('');
  const [opcoesModal, atribuirOpcoesModal] = useState({ open: false });
  const [param, atribuirParametro] = useState({
    pagina: 1,
    registroPorPagina: 30,
    ordenarDecrescente: false,
  });
  const [totalPaginas, atribuirTotalDePaginas] = useState(0);
  const [totalRegistro, atribuirTotalDeRegistro] = useState(0);
  const [usuarios, atribuirUsuarios] = useState([]);

  const historico = useHistory();

  const formRef = useRef(null);

  const enviarFormulario = useCallback((data) => {
    atribuirFiltros(data);
  }, []);

  const excluir = useCallback(
    async (id) => {
      UsuarioInstituicaoStore.excluir(id).then((response) => {
        if (response.status === 200) {
          toast.success(response.data.mensagem);
          atribuirParametro({ ...param });
        } else if (response.status >= 400 && response.status < 500)
          toast.error(response.data.mensagem);
        else toast.error(response.data.message);

        atribuirOpcoesModal({ open: false });
      });
    },
    [param],
  );

  const obterInstituicoes = useCallback(async (dependencia, municipio) => {
    if (dependencia === '' || municipio === '') {
      atribuirInstituicoes([]);
      return;
    }

    await InstituicaoStore.obterInstituicoesFiltradas({
      dependenciaAdministrativa: dependencia,
      municipio,
    }).then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          atribuirInstituicoes([
            { label: 'Selecione', value: '' },
            ...response.data.map((item) => ({
              label: item.nome,
              value: item.id,
            })),
          ]);
        } else {
          atribuirInstituicoes([]);
          toast.error(
            'Não há instituições cadastradas para a dependência administrativa informada.',
          );
        }
      } else toast.error(response.data.mensagem);
    });
  }, []);

  const abrirModal = (vinculo) => {
    atribuirOpcoesModal({ open: true, id: vinculo.id });
  };

  const acoesRegistroTabela = [
    {
      texto: '',
      icone: 'FaTrashAlt',
      cor: 'danger',
      aoClicar: abrirModal,
      retornarObjeto: true,
      tooltip: 'Excluir',
    },
  ];

  const acoesModal = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModal({ open: false })}
        cor='background'
      />
      <Botao texto='Excluir' aoClicar={() => excluir(opcoesModal.id)} cor='danger' />
    </>
  );

  const acoesTabela = (
    <Botao cor='success' texto='Novo vínculo' aoClicar={() => redirecionar('/usuario/novo')}>
      <Icone nome='FaPlus' tamanho={16} />
    </Botao>
  );

  const colunas = [
    {
      nome: 'Nome',
      propriedade: 'nome',
      largura: '20%',
      filtrado: true,
    },
    {
      nome: 'CPF',
      propriedade: 'cpf',
      largura: '15%',
      ordenavel: true,
      filtrado: true,
      mascara: true,
    },
    {
      nome: 'Dependência administrativa',
      propriedade: 'dependenciaAdministrativa',
      ordenavel: true,
      largura: '20%',
      filtrado: true,
    },
    {
      nome: 'Instituição',
      propriedade: 'nomeInstituicaoDeEnsino',
      ordenavel: true,
      largura: '18%',
      filtrado: true,
    },
    {
      nome: 'Município',
      propriedade: 'municipio',
      ordenavel: true,
      largura: '15%',
      filtrado: true,
    },
  ];

  const limparFiltros = () => {
    formRef.current.reset();
    atribuirMunicipioNome('');
    atribuirDependencia('');
    atribuirInstituicoes([]);
    atribuirFiltros({});
  };

  const mudarDependencia = (value) => {
    atribuirDependencia(value);
    obterInstituicoes(value, municipioNome);
  };

  const mudarMunicipio = (value) => {
    atribuirMunicipioNome(value);
    obterInstituicoes(dependencia, value);
  };

  const mudarPagina = (params) => {
    atribuirParametro({ ...param, pagina: params });
  };

  const controlarModal = () => {
    atribuirOpcoesModal({ open: false });
  };

  const redirecionar = (link) => {
    historico.push(link);
  };

  useEffect(() => {
    const call = async () => {
      await MunicipioStore.obterMunicipios({}).then((response) => {
        if (response.status === 200) {
          atribuirMunicipios([
            { label: 'Selecione', value: '' },
            ...response.data.map((item) => ({
              label: item.nome,
              value: item.nome,
            })),
          ]);
        } else if (response.status === 204) {
          toast.error('Não há municípios cadastrados');
        } else toast.error(response.data.mensagem);
      });
    };

    call();
  }, []);

  useEffect(() => {
    const call = async () => {
      await UsuarioInstituicaoStore.obterFiltrado({ ...param, ...filtros }).then((response) => {
        if (response.status === 200) {
          atribuirUsuarios(response.data.lista);
          atribuirTotalDePaginas(response.data.totalDePaginas);
          atribuirTotalDeRegistro(response.data.totalDeRegistros);
        } else {
          toast.error(response.data.mensagem);
        }
      });
    };

    call();
  }, [filtros, param]);

  return (
    <CorpoDaPagina titulo='Usuários'>
      <Formulario ref={formRef} onSubmit={enviarFormulario}>
        <CampoConteiner>
          <Input titulo='CPF' nome='cpf' mascara placeholder={'Informe o CPF'} />

          <Seletor
            nome='municipio'
            titulo='Município'
            aoAtribuirValor={mudarMunicipio}
            opcoes={municipios}
            desabilitado={municipios.length === 0}
          />
          <Seletor
            nome='dependenciaAdministrativa'
            titulo='Dependência administrativa'
            aoAtribuirValor={mudarDependencia}
            opcoes={[
              { label: 'Selecione', value: '' },
              { label: 'Federal', value: 'Federal' },
              { label: 'Privada', value: 'Privada' },
              { label: 'Municipal', value: 'Municipal' },
              { label: 'Estadual', value: 'Estadual' },
            ]}
          />
        </CampoConteiner>
        <CampoConteiner>
          <Seletor
            nome='instituicaoDeEnsinoId'
            titulo='Instituição de ensino'
            opcoes={instituicoes}
            desabilitado={instituicoes.length === 0}
          />
          <ConteinerBotoes>
            <Botao texto='Limpar filtros' cor='danger' outlined aoClicar={() => limparFiltros()} />
            <Botao texto='Filtrar' tipo='submit' />
          </ConteinerBotoes>
        </CampoConteiner>
      </Formulario>

      <Tabela
        colunas={colunas}
        acoesDoRegistro={acoesRegistroTabela}
        dados={usuarios}
        acoesDaTabela={acoesTabela}
        aoMudarDePagina={mudarPagina}
        totalDePaginas={totalPaginas}
        totalDeRegistros={totalRegistro}
        registrosPorPagina={param.registroPorPagina}
        aoOrdenar={(column, desc) =>
          atribuirParametro({ ...param, ordenarPor: column, ordenarDecrescente: desc })
        }
        ordenacaoDecresente={param.ordenarDecrescente}
        ordenarPor={param.ordenarPor}
      />
      {opcoesModal.open && (
        <Modal titulo='Excluir vínculo' acoes={acoesModal} controleAberturaModal={controlarModal}>
          <span>Deseja excluir este vínculo?</span>
        </Modal>
      )}
    </CorpoDaPagina>
  );
}

export default Usuario;
